/*** IMPORTS FROM imports-loader ***/
import "core-js/modules/es.promise";
import "core-js/modules/es.array.iterator";

import 'lightgallery.js';
import 'lg-video.js';
import 'lg-thumbnail.js';

export default window.lightGallery;